import { pciProxy } from '../../../../../../../services/pciProxy';
import { connectCheckoutField } from '../../../../../utils/connectCheckoutField';
import { invokePciProxy } from '../../utils/invokePciProxy';

const { updateCvvMetadata } = pciProxy.actions;

export const inject = connectCheckoutField({
    mapAdditionalDispatchProps: (dispatch: $TSFixMe) => ({
        onMetadataChange: (metadata: $TSFixMe) => dispatch(updateCvvMetadata(metadata)),
        registerChange: invokePciProxy('registerCvvChange', dispatch),
        registerFocus: invokePciProxy('registerCvvFocus', dispatch),
        registerBlur: invokePciProxy('registerCvvBlur', dispatch),
        setStyle: invokePciProxy('setCvvStyle', dispatch),
    }),
});
